import { fetchJSON } from "./utils";

export async function fetchAll(organizationId) {
  const url = "/api/department/";
  let params = null;
  if (organizationId) {
    params = { organization_id: organizationId };
  }
  return fetchJSON(url, params, null, "get", false);
}

export async function fetchOne(dptId) {
  const url = `/api/department/${dptId}`;
  return fetchJSON(url, null, null, "get");
}

export async function createDepartment(data) {
  const url = "/api/department/";
  return fetchJSON(url, null, data, "post");
}

export async function updateDepartment(id, data) {
  const url = `/api/department/${id}`;
  return fetchJSON(url, null, data, "put");
}

export async function deleteDepartment(id) {
  const url = `/api/department/${id}`;
  return fetchJSON(url, null, null, "delete");
}

export async function getTags(organizationId) {
  const url = `/api/department/tags`;
  let params = null;
  if (organizationId) {
    params = { organization_id: organizationId };
  }
  return fetchJSON(url, params, null, "get");
}
